
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const HeroSection = () => {
  const images = [
    "https://cdn.pixabay.com/photo/2015/06/29/13/04/peaches-825564_1280.jpg",
    "https://cdn.pixabay.com/photo/2017/09/26/13/31/apple-2788616_1280.jpg",
    "https://cdn.pixabay.com/photo/2016/10/25/15/39/meat-1769187_1280.jpg",
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images.length]);

  const heroStyles = {
    backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.3)), url('${images[currentImageIndex]}')`,
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    transition: "background-image 1.5s ease-in-out",
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  };

  const headerStyle = {
    fontFamily: "'Cinzel Decorative', serif",
    color: "#fff",
    textShadow: "2px 2px 8px rgba(0,0,0,0.7)",
    fontSize: "3.8rem",
    letterSpacing: "2px",
    textTransform: "uppercase",
    marginBottom: "1rem",
  };

  const subtextStyle = {
    color: "#fff",
    fontWeight: "300",
    fontSize: "1.25rem",
    textShadow: "1px 1px 6px rgba(0,0,0,0.5)",
    marginBottom: "2rem",
  };

  return (
    <div className="hero-section" style={heroStyles}>
      <div>
        {/* Optional Logo */}
      
       

        <h1 style={headerStyle}>DISCOVER FOOD DONE RIGHT</h1>
        <p style={subtextStyle}>
          Your premium source for fresh produce delivered right to your door.
        </p>
        <p
          className="fs-6 fw-medium mb-4 text-white"
        >
          Committed to serving freshness since 2024
        </p>

        <Link to="/products">
          <button
            className="btn btn-lg px-5 py-3"
            style={{
              background: "linear-gradient(135deg, #198754, #000000)",
              border: "none",
              borderRadius: "50px",
              color: "white",
              fontWeight: "600",
              fontSize: "1.1rem",
              boxShadow: "0 8px 25px rgba(25, 135, 84, 0.3)",
              transition: "all 0.3s ease",
              minWidth: "180px",
            }}
            onMouseOver={(e) => {
              e.target.style.transform = "translateY(-3px)";
              e.target.style.boxShadow = "0 12px 35px rgba(25, 135, 84, 0.4)";
            }}
            onMouseOut={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 8px 25px rgba(25, 135, 84, 0.3)";
            }}
          >
            Shop Now
          </button>
        </Link>
      </div>

      {/* Include font in page */}
      <style jsx="true">{`
        @import url("https://fonts.googleapis.com/css2?family=Cinzel+Decorative:wght@700&display=swap");

        @media (max-width: 768px) {
          h1 {
            font-size: 2.8rem !important;
          }
        }

        @media (max-width: 480px) {
          h1 {
            font-size: 2rem !important;
          }

          p {
            font-size: 1rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default HeroSection;
